export default "__VITE_ASSET__BKBHsQKQ__"